module.exports = __webpack_public_path__ + "static/img/9.7c9f34f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/9.png
// module id = sppF
// module chunks = 0